import React from "react";
import { X } from "lucide-react";

const CapacitacionForm = ({
    formData,
    setFormData,
    editingId,
    setEditingId,
    capacitacionActivaEditando,
    setMostrarFormulario,
    handleSubmit,
    temasCapacitacion,
    onClose
}) => {
    const formatearMonto = (valor) => {
        if (!valor || valor === '') return '0.00';
        const soloNumeros = valor.replace(/[^0-9]/g, '');
        if (soloNumeros === '') return '0.00';
        const centavos = parseInt(soloNumeros);
        const decimal = (centavos / 100).toFixed(2);
        return decimal;
    };

    const handleMontoChange = e => {
        const valor = e.target.value;
        if (valor === '') {
            setFormData({ ...formData, monto: '' });
            return;
        }
        setFormData({ ...formData, monto: formatearMonto(valor) });
    };

    const handleMontoFocus = () => {
        if (formData.monto === '0.00') {
            setFormData({ ...formData, monto: '' });
        }
    };

    const handleMontoBlur = () => {
        if (formData.monto === '') {
            setFormData({ ...formData, monto: '0.00' });
        }
    };

    const fechaMinima = new Date();
    fechaMinima.setDate(fechaMinima.getDate() - 45);
    const minFecha = fechaMinima.toISOString().split("T")[0];

    return (
        <>
            {/* Overlay de fondo */}
            <div
                onClick={onClose}
                style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0, 0, 0, 0.4)",
                    zIndex: 999,
                }}
            />

            {/* Modal centrado */}
            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "min(520px, 94vw)",
                    maxHeight: "90vh",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                {/* Header fijo */}
                <div
                    style={{
                        padding: "20px 28px 16px",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexShrink: 0,
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: "17px", fontWeight: 600, color: "#1a1a1a" }}>
                        {editingId ? "Editar Capacitación" : "Registrar Capacitación"}
                    </h3>
                    <button
                        onClick={onClose}
                        title="Cerrar"
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            color: "#555",
                        }}
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Cuerpo con scroll */}
                <div
                    style={{
                        overflowY: "auto",
                        flex: 1,
                        padding: "20px 28px 24px",
                    }}
                >
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        {/* Nombre del evento */}
                        <div style={styles.field}>
                            <label style={styles.label}>Nombre del evento</label>
                            <input
                                value={formData.nombreEvento}
                                onChange={e => setFormData({ ...formData, nombreEvento: e.target.value })}
                                required
                                placeholder="Ej. Taller de liderazgo organizacional"
                                style={styles.input}
                            />
                        </div>

                        {/* Lugar */}
                        <div style={styles.field}>
                            <label style={styles.label}>Lugar</label>
                            <input
                                value={formData.lugar}
                                onChange={e => setFormData({ ...formData, lugar: e.target.value })}
                                required
                                placeholder="Ej. Ciudad de Guatemala"
                                style={styles.input}
                            />
                        </div>

                        {/* Fechas */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "16px" }}>
                            <div>
                                <label style={styles.label}>Fecha inicio</label>
                                <input
                                    type="date"
                                    value={formData.fechaInicio}
                                    min={minFecha}
                                    onChange={e => {
                                        const nuevaFecha = e.target.value;

                                        // Si la fecha fin queda antes de la fecha inicio, limpiar
                                        if (
                                            formData.fechaFin &&
                                            new Date(nuevaFecha) > new Date(formData.fechaFin)
                                        ) {
                                            setFormData({
                                                ...formData,
                                                fechaInicio: nuevaFecha,
                                                fechaFin: ""
                                            });
                                        } else {
                                            setFormData({
                                                ...formData,
                                                fechaInicio: nuevaFecha
                                            });
                                        }
                                    }}
                                    required
                                    style={styles.input}
                                />
                            </div>

                            <div>
                                <label style={styles.label}>Fecha fin</label>
                                <input
                                    type="date"
                                    value={formData.fechaFin}
                                    min={formData.fechaInicio || minFecha}
                                    onChange={e =>
                                        setFormData({
                                            ...formData,
                                            fechaFin: e.target.value
                                        })
                                    }
                                    required
                                    style={styles.input}
                                />
                            </div>
                        </div>

                        {/* Institución */}
                        <div style={styles.field}>
                            <label style={styles.label}>Institución facilitadora</label>
                            <input
                                value={formData.institucion}
                                onChange={e => setFormData({ ...formData, institucion: e.target.value })}
                                required
                                placeholder="Ej. INTECAP"
                                style={styles.input}
                            />
                        </div>

                        {/* Temas */}
                        <div style={styles.field}>
                            <label style={styles.label}>Temas de formación</label>
                            <div
                                style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "8px",
                                    padding: "10px 12px",
                                    maxHeight: "160px",
                                    overflowY: "auto",
                                    background: "#fafafa",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                }}
                            >
                                {temasCapacitacion.map((tema) => (
                                    <label
                                        key={tema.idtemacapacitacion}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            fontSize: "14px",
                                            cursor: "pointer",
                                            color: "#333",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={formData.temas.includes(
                                                tema.idtemacapacitacion
                                            )}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setFormData({
                                                        ...formData,
                                                        temas: [
                                                            ...formData.temas,
                                                            tema.idtemacapacitacion
                                                        ]
                                                    });
                                                } else {
                                                    setFormData({
                                                        ...formData,
                                                        temas: formData.temas.filter(
                                                            id =>
                                                                id !==
                                                                tema.idtemacapacitacion
                                                        )
                                                    });
                                                }
                                            }}
                                        />
                                        {tema.nombretema}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Monto */}
                        <div style={styles.field}>
                            <label style={styles.label}>Monto Previsto</label>
                            <div style={{ position: "relative" }}>
                                <span
                                    style={{
                                        position: "absolute",
                                        left: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        fontSize: "14px",
                                        color: "#666",
                                        pointerEvents: "none",
                                        userSelect: "none",
                                    }}
                                >
                                    Q
                                </span>
                                <input
                                    type="text"
                                    value={formData.monto}
                                    onChange={handleMontoChange}
                                    onFocus={handleMontoFocus}
                                    onBlur={handleMontoBlur}
                                    placeholder="0.00"
                                    required
                                    style={{ ...styles.input, textAlign: "right", paddingLeft: "28px" }}
                                />
                            </div>
                        </div>

                        {/* Observaciones */}
                        <div style={styles.field}>
                            <label style={styles.label}>Observaciones</label>
                            <textarea
                                value={formData.observacion}
                                onChange={e => setFormData({ ...formData, observacion: e.target.value })}
                                rows={3}
                                placeholder="Ingrese observaciones sobre la capacitación"
                                style={{
                                    ...styles.input,
                                    resize: "vertical",
                                    minHeight: "80px",
                                    fontFamily: "inherit",
                                    lineHeight: "1.5",
                                }}
                            />
                        </div>

                        {/* Botón submit */}
                        <button
                            type="submit"
                            style={{
                                width: "100%",
                                padding: "11px",
                                background: "#219ebc",
                                color: "#fff",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontWeight: 600,
                                fontSize: "15px",
                                marginTop: "4px",
                                transition: "background 0.2s",
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = "#197a94"}
                            onMouseLeave={e => e.currentTarget.style.background = "#219ebc"}
                        >
                            {editingId ? "Actualizar" : "Guardar"}
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

const styles = {
    field: {
        marginBottom: "16px",
    },
    label: {
        display: "block",
        marginBottom: "6px",
        fontSize: "13px",
        fontWeight: 500,
        color: "#555",
    },
    input: {
        width: "100%",
        padding: "9px 12px",
        borderRadius: "8px",
        border: "1px solid #ddd",
        fontSize: "14px",
        color: "#1a1a1a",
        background: "#fff",
        boxSizing: "border-box",
        outline: "none",
        fontFamily: "inherit",
    },
};

export default CapacitacionForm;